var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
        },
        scopedSlots: _vm._u([
          {
            key: "customActions",
            fn: function() {
              return [
                _c(
                  "action-button",
                  {
                    staticClass: "mr-2 d-block",
                    attrs: {
                      i: "fas fa-arrow-circle-left",
                      variant: "success"
                    },
                    on: {
                      click: function($event) {
                        return _vm.goToAnnouncementBoard()
                      }
                    }
                  },
                  [_vm._v(" Regresar ")]
                ),
                _vm.hasPrintPermission
                  ? _c(
                      "action-button",
                      {
                        staticClass: "mr-2 d-block",
                        attrs: {
                          i: "fas fa-print",
                          variant: "outline-success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onDownloadProposalProcessReport()
                          }
                        }
                      },
                      [_vm._v(" Imprimir ")]
                    )
                  : _vm._e(),
                _vm.hasReportsPermission
                  ? _c("dropdown", {
                      staticClass: "reports-dropdown actions-dropdown",
                      attrs: {
                        icon: "fas fa-folders",
                        items: _vm.dropdownHeaderActions,
                        responsive: "",
                        title: "Informes"
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("filter-manager", {
        ref: "filterRef",
        staticClass: "mb-4",
        attrs: { "display-advanced": false, filters: _vm.filtersConfig },
        on: { search: _vm.onSearchHandler, service: () => {} },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultados" }
      }),
      _vm.results.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No cuenta con información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(row) {
        return _c(
          "div",
          { key: row.id },
          [_c("result-row", { attrs: { data: row } })],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }